const DecimalNumber = 10;

export default {
  Default: DecimalNumber,
};
